import { Avatar, Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

type Props = {
  rank: number;
  name: string;
  score: number;
  scoreIcon: ReactNode;
  isAnonymous?: boolean;
  isCurrentUser?: boolean;
  profilePicture?: string | null;
};

export const LeaderboardItem = ({
  rank,
  name,
  score,
  scoreIcon,
  profilePicture,
  isAnonymous = false,
  isCurrentUser = false,
}: Props) => (
  <Box
    display="flex"
    alignItems="center"
    gap={2}
    py={2}
    px={4}
    borderRadius={1.25}
    bgcolor={isCurrentUser ? "primary.main" : "background.paper"}
    boxShadow="0px 1px 5px 0px rgba(0, 0, 0, 0.20)"
    sx={
      isCurrentUser
        ? ({ palette }) => ({ color: palette.primary.contrastText })
        : undefined
    }
  >
    <Typography
      fontWeight={600}
      fontSize="0.875rem"
      minWidth="3ch"
      color={isCurrentUser ? "inherit" : "text.secondary"}
    >
      {rank}.
    </Typography>
    <Avatar
      src={profilePicture || undefined}
      sx={({ palette }) => ({
        width: 26,
        height: 26,
        bgcolor: isCurrentUser
          ? palette.primary.contrastText
          : palette.grey[300],
        color: isCurrentUser ? palette.primary.main : "inherit",
        fontSize: 14,
      })}
    >
      {!profilePicture && (isAnonymous ? "?" : name[0].toUpperCase())}
    </Avatar>
    <Typography
      flex={1}
      fontWeight={500}
      fontSize="0.875rem"
      color={isCurrentUser ? "inherit" : "text.primary"}
    >
      {name}
    </Typography>
    <Box display="flex" alignItems="center" gap={1}>
      <Typography fontWeight={600} fontSize="0.875rem" color="inherit">
        {score}
      </Typography>
      <Box
        display="flex"
        alignItems="center"
        color={isCurrentUser ? "inherit" : "text.secondary"}
        sx={{ "& > svg": { fontSize: 16 } }}
      >
        {scoreIcon}
      </Box>
    </Box>
  </Box>
);
